import * as B from '@blueprintjs/core';
import classnames from 'classnames';
import React from 'react';

import {ApiProject} from 'app/modules/Remote/Project';
import colors, {getTextContrastColor} from 'app/utils/colorUtils';

import cs from './MultiFeatureAnalysisTable.module.scss';
import {ProjectFilter} from '../utils/chartUtils';

export const ProjectFilterMenu: React.FC<{
  projectFilterMode: ProjectFilter['projectFilterMode'];
  projectIds: string[];
  projectIdsDict: Record<string, ApiProject>;
  applyProjectFilter: (
    projectIds: string[],
    projectFilterMode: ProjectFilter['projectFilterMode']
  ) => void;
}> = ({projectFilterMode, projectIds, projectIdsDict, applyProjectFilter}) => {
  return (
    <div className={cs.tagFilterMenuContainer}>
      <div className={cs.tagFilterDescription}>
        <span>Show properties belonging to</span>
        <B.ButtonGroup>
          <B.Button
            text="any"
            active={projectFilterMode === 'any'}
            onClick={() => applyProjectFilter(projectIds, 'any')}
            small
          />
          <B.Button
            text="none"
            active={projectFilterMode === 'none'}
            onClick={() => applyProjectFilter(projectIds, 'none')}
            small
          />
        </B.ButtonGroup>
        <span>of the following portfolios:</span>
      </div>
      <div className={cs.tagFilterMenu}>
        <div className={cs.tagItemsContainer}>
          {Object.keys(projectIdsDict).map((projectId) => {
            const isSelected = projectIds.includes(projectId);
            return (
              <div
                key={projectId}
                onClick={() => {
                  const newSelectedTags = projectIds.includes(projectId)
                    ? projectIds.filter((id) => id !== projectId)
                    : [...projectIds, projectId];
                  applyProjectFilter(newSelectedTags, projectFilterMode);
                }}
                className={classnames(cs.tagItem, cs.hoverEmphasisLight, {
                  [cs.tagSelected]: isSelected,
                })}
                style={{
                  backgroundColor: colors.lighterGray,
                  color: getTextContrastColor(colors.lighterGray),
                }}
              >
                <span
                  className={B.Classes.TEXT_OVERFLOW_ELLIPSIS}
                  style={{maxWidth: '150px'}}
                  title={projectIdsDict[projectId].name}
                >
                  {projectIdsDict[projectId].name}
                </span>
                {isSelected && <B.Icon icon="tick" className={cs.tagItemIcon} size={14} />}
              </div>
            );
          })}
        </div>
      </div>
      <B.Button
        onClick={() => applyProjectFilter([], 'any')}
        minimal
        className={cs.tagFilterResetButton}
        disabled={projectIds.length === 0 && projectFilterMode === 'any'}
      >
        Reset
      </B.Button>
    </div>
  );
};
